import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';
import {t, Trans} from '@lingui/macro';
import debounce from 'lodash.debounce';

import {sendPasswordReset} from '../../actions/login';
import {isResettingPassword} from '../../reducers/ui';

import SkillupLogo from '../../components/Icons/SkillupLogo';
import Button from '../../components/Button';

import {LOGIN} from '../../services/routes';
import {getSuffix} from '@services/utilities';

import cl from 'classnames';
import s from './ResetPassword.css';

class ResetPassword extends Component {
  state = {
    email: '',
  };
  debouncedReset = debounce(this.props.sendPasswordReset, 200);

  onEmailChange = event => this.setState({email: event.target.value});

  onSubmit = event => {
    const {email} = this.state;
    this.debouncedReset(email);
    event.preventDefault();
  };

  goToLoginPage = e => {
    this.props.push(LOGIN);
    e.stopPropagation();
    e.preventDefault();
  };

  render() {
    const {isResettingPassword} = this.props;
    const {email} = this.state;
    const isActive = typeof email !== 'undefined' && email.length > 0;

    return (
      <div className={cl(s.LoginPage)}>
        <SkillupLogo className={s.Logo} negative size="38px" />

        <p className={s.Welcome}>
          <Trans id="reset_password.title">Reset della password</Trans>
        </p>

        <section className={s.LoginForm}>
          <form onSubmit={this.onSubmit}>
            <section>
              <input
                type="text"
                className={s.TextField}
                placeholder={t({
                  id: `reset_password.placeholder_email`,
                  message: 'Email',
                })}
                value={email}
                onChange={this.onEmailChange}
              />
            </section>

            <section className={s.ButtonContainer}>
              <Button
                className={cl(s.SendButton, isActive && s.Active)}
                loading={isResettingPassword}
              >
                <Trans
                  render={({translation}) => <span>{translation}</span>}
                  id="reset_password.button_reset"
                >
                  Reset
                </Trans>
              </Button>
            </section>
          </form>
        </section>

        <p className={s.PasswordReset}>
          <a href="#" onClick={this.goToLoginPage}>
            <Trans id="reset_password.link_return_to_login">Ritorna al login</Trans>
          </a>
        </p>

        <p className={s.Copyright}>{`Skillup © ${new Date().getFullYear()} ${getSuffix()}`}</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isResettingPassword: isResettingPassword(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({sendPasswordReset, push}, dispatch);
}

export const ConnectedResetPassword = connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
